import { Component } from '@angular/core';
import { IonicPage, NavController, NavParams,ModalController } from 'ionic-angular';
import { ApiUserProvider } from '../../providers/api-user/api-user';
import { DatePipe } from '@angular/common';
import { Http } from '@angular/http';
import { ReserveModalPage } from '../../pages/reserve-modal/reserve-modal';
//import { Observable } from 'rxjs';
import 'rxjs/add/operator/map';
//import { map } from 'rxjs/operators';

import { AlertController } from 'ionic-angular';
import { LoadingController } from 'ionic-angular';
/**
 * Generated class for the DoctorPage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */

@Component({
  selector: 'page-doctor',
  templateUrl: 'doctor.html',
})
export class DoctorPage {
  JobList : Array<any>=[];
  DateFrom: Date = new Date();//.toISOString();
  //DateTo: Date= new Date(); //.toISOString();
  Visible:boolean=true;
  constructor(public modalController:ModalController,public navCtrl: NavController, public navParams: NavParams,
    public apiUserProvider:ApiUserProvider//,private storage: Storage
   ,private http:Http,public alertCtrl: AlertController,public loadingCtrl: LoadingController
   ,public datepipe: DatePipe) {
  }

  ionViewDidLoad() {
    console.log('ionViewDidLoad DoctorPage');
  }
  public openModal(item1:any){
    var item = { 'Serial' : item1.RSerial,'Note' : item1.RNote,'Date':item1.RDate ,
    'FileName': this.apiUserProvider.MyDomain+'/Images/'+ item1.RFileName+".jpg" };
    var modalPage = this.modalController.create(ReserveModalPage,
      item);
    modalPage.present();
  //  modalPage.onDidDismiss(data => {
   //   item1.eval=data.rate;
   //   item1.note=data.note;
     
  // });
}
View()
{
  let loader = this.loadingCtrl.create({
    content: "Please wait...",
    //duration: 3000,
  });
  loader.present();
  let Df=this.datepipe.transform(this.DateFrom, 'yyyy-MM-dd');
  this.http.get(this.apiUserProvider.MyDomain+'/api/Default/GetReservations/'
  +this.apiUserProvider.ClinicID+'-'+this.apiUserProvider.USerial+'-'+Df)
  .map(res => res.json()).subscribe(data => {         
       this.JobList = data;
       //if(this.JobList !== undefined && this.JobList.length>0)
     
       //this.Visible=true;
       //else
       //this.Visible=false;
       loader.dismiss();
  },err => {
    console.log(err);
    loader.dismiss();
    const alert = this.alertCtrl.create({
      title: 'Error message',
      subTitle: err,
      buttons: ['OK']
    });
    alert.present();
    });
  
}
}



// WEBPACK FOOTER //
// ./src/pages/doctor/doctor.ts